import createBrowserHistory from '../node_modules/history/createBrowserHistory';

export default createBrowserHistory({
})